import { useRef, useState, useEffect } from 'react'
import { Link, NavLink } from 'react-router-dom'

const CLOSE_DELAY_MS = 180

export default function DropdownNav({ label, to, items, isMobile = false, onNavigate }) {
  const [open, setOpen] = useState(false)
  const closeTimer = useRef(null)

  useEffect(() => () => clearTimeout(closeTimer.current), [])

  const openNow = () => {
    clearTimeout(closeTimer.current)
    setOpen(true)
  }
  const closeWithDelay = () => {
    clearTimeout(closeTimer.current)
    closeTimer.current = setTimeout(() => setOpen(false), CLOSE_DELAY_MS)
  }

  if (isMobile) {
    return (
      <div>
        <button
          type="button"
          onClick={() => setOpen(o => !o)}
          className="w-full flex items-center justify-between py-2.5 text-white/80 hover:text-ecbc-sky text-sm transition-colors"
          aria-expanded={open}
        >
          {label}
          <svg className={`w-4 h-4 transition-transform ${open ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>
        {open && (
          <div className="mb-1 ml-3 flex flex-col border-l border-white/10 pl-4">
            <Link to={to} onClick={onNavigate} className="block py-2 text-white/60 hover:text-ecbc-sky text-sm transition-colors">
              {label} Overview
            </Link>
            {items.map(({ to: itemTo, label: itemLabel, badge }) => (
              <Link key={itemTo} to={itemTo} onClick={onNavigate} className="flex items-center gap-2 py-2 text-white/60 hover:text-ecbc-sky text-sm transition-colors">
                {itemLabel}
                {badge && (
                  <span className="text-[10px] font-semibold uppercase tracking-wide text-ecbc-navy bg-ecbc-sky px-1.5 py-0.5 rounded-full">
                    {badge}
                  </span>
                )}
              </Link>
            ))}
          </div>
        )}
      </div>
    )
  }

  return (
    <div
      className="relative"
      onMouseEnter={openNow}
      onMouseLeave={closeWithDelay}
    >
      <NavLink
        to={to}
        className={({ isActive }) =>
          `flex items-center gap-1 ${isActive ? 'text-ecbc-sky font-semibold' : 'text-white/80 hover:text-ecbc-sky'} transition-colors duration-200`
        }
      >
        {label}
        <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </NavLink>

      <div
        className={`absolute left-0 top-full pt-2 transition-all duration-150 ${
          open ? 'opacity-100 translate-y-0 visible' : 'opacity-0 -translate-y-1 invisible'
        }`}
      >
        <div className="bg-white rounded-lg shadow-lg border border-gray-100 py-2 min-w-[220px]">
          {items.map(({ to: itemTo, label: itemLabel, badge }) => (
            <Link
              key={itemTo}
              to={itemTo}
              className="flex items-center justify-between gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-ecbc-gray hover:text-ecbc-navy transition-colors"
            >
              <span>{itemLabel}</span>
              {badge && (
                <span className="text-[10px] font-semibold uppercase tracking-wide text-ecbc-navy bg-ecbc-sky/30 px-1.5 py-0.5 rounded-full">
                  {badge}
                </span>
              )}
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
}
